import { render, staticRenderFns } from "./UserFieldTypeOptionsOverview.vue?vue&type=template&id=efefac74&scoped=true&"
import script from "./UserFieldTypeOptionsOverview.vue?vue&type=script&lang=js&"
export * from "./UserFieldTypeOptionsOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserFieldTypeOptionsOverview.vue?vue&type=style&index=0&id=efefac74&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efefac74",
  null
  
)

export default component.exports